export default {
  // YouTube Link Generator
  'link.mainTitle': 'YouTube टाइमस्टैम्प लिंक जनरेटर',
  'link.mainTitleSEO': 'YouTube टाइमस्टैम्प लिंक जनरेटर - साझा करने योग्य वीडियो लिंक बनाएं',
  'link.subtitle': 'विशिष्ट समय पर शुरू होने वाले YouTube लिंक जनरेट करें - साझा करने के लिए बिल्कुल सही',

  // Link Generator Tool
  'link.generatorTitle': 'टाइमस्टैम्प के साथ YouTube लिंक बनाएं',
  'link.pasteUrl': 'YouTube URL पेस्ट करें:',
  'link.urlPlaceholder': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  'link.startTime': 'शुरू होने का समय:',
  'link.hours': 'घंटे',
  'link.minutes': 'मिनट',
  'link.seconds': 'सेकंड',
  'link.orEnterSeconds': 'या कुल सेकंड दर्ज करें:',
  'link.secondsPlaceholder': 'उदा., 90',

  // Output Section
  'link.generatedLinks': 'जनरेट किए गए साझा करने योग्य लिंक:',
  'link.shortLink': 'संक्षिप्त लिंक (अनुशंसित):',
  'link.fullLink': 'पूर्ण लिंक:',
  'link.embedCode': 'एम्बेड कोड:',
  'link.preview': 'पूर्वावलोकन:',
  'link.copyLink': 'लिंक कॉपी करें',
  'link.copyEmbed': 'एम्बेड कॉपी करें',

  // URL Formats
  'link.urlFormats': 'YouTube टाइमस्टैम्प URL प्रारूप समझाया गया',
  'link.format1Title': '1. क्वेरी पैरामीटर प्रारूप (?t=)',
  'link.format1Desc': 'किसी भी YouTube URL में ?t= या &t= जोड़ें:',
  'link.format1Example1': '?t=90 - 90 सेकंड (1 मिनट 30 सेकंड)',
  'link.format1Example2': '?t=1m30s - 1 मिनट 30 सेकंड',
  'link.format1Example3': '?t=1h5m30s - 1 घंटा 5 मिनट 30 सेकंड',

  'link.format2Title': '2. हैश फ्रैगमेंट प्रारूप (#t=)',
  'link.format2Desc': '#t= का उपयोग करते हुए पुराना प्रारूप:',

  'link.format3Title': '3. मोबाइल ऐप डीप लिंक',
  'link.format3Desc': 'मोबाइल साझाकरण के लिए:',

  'link.format4Title': '4. स्टार्ट पैरामीटर के साथ एम्बेड URL',
  'link.format4Desc': 'एम्बेडेड वीडियो के लिए:',

  // Use Cases
  'link.useCases': 'टाइमस्टैम्प लिंक का उपयोग कब करें',
  'link.useCase1Title': '📱 सोशल मीडिया साझाकरण',
  'link.useCase1Desc': 'Twitter, Facebook, Reddit पर सटीक क्षणों को साझा करें',

  'link.useCase2Title': '📧 ईमेल संदर्भ',
  'link.useCase2Desc': 'प्रशिक्षण वीडियो के विशिष्ट भागों में सहकर्मियों को भेजें',

  'link.useCase3Title': '📝 ब्लॉग उद्धरण',
  'link.useCase3Desc': 'लेखों में विशिष्ट वीडियो साक्ष्य से लिंक करें',

  'link.useCase4Title': '💬 फ़ोरम चर्चा',
  'link.useCase4Desc': 'वीडियो बहस में सटीक क्षणों का संदर्भ दें',

  'link.useCase5Title': '🎓 शैक्षिक सामग्री',
  'link.useCase5Desc': 'छात्रों को विशिष्ट पाठ खंडों पर निर्देशित करें',

  'link.useCase6Title': '🎬 वीडियो समीक्षा',
  'link.useCase6Desc': 'विशिष्ट दृश्यों या क्षणों को हाइलाइट करें',

  // FAQ
  'link.faq': 'YouTube टाइमस्टैम्प लिंक FAQ',

  'link.faq.q1': 'क्या YouTube टाइमस्टैम्प लिंक मोबाइल पर काम करते हैं?',
  'link.faq.a1': 'हां! ?t= और #t= दोनों प्रारूप मोबाइल ब्राउज़र और YouTube ऐप पर काम करते हैं। लिंक ऐप में खुलेगा यदि इंस्टॉल है, या मोबाइल ब्राउज़र में।',

  'link.faq.q2': 'क्या मैं एम्बेडेड वीडियो में टाइमस्टैम्प लिंक का उपयोग कर सकता हूं?',
  'link.faq.a2': 'हां, एम्बेड URL में start= पैरामीटर का उपयोग करें: <iframe src="https://www.youtube.com/embed/VIDEO_ID?start=90"></iframe>',

  'link.faq.q3': 'क्या टाइमस्टैम्प लिंक YouTube Shorts के साथ काम करते हैं?',
  'link.faq.a3': 'नहीं, YouTube Shorts वर्तमान में टाइमस्टैम्प पैरामीटर का समर्थन नहीं करते हैं। टाइमस्टैम्प लिंक केवल नियमित YouTube वीडियो के साथ काम करते हैं।',

  'link.faq.q4': 'क्या टाइमस्टैम्प लिंक हमेशा काम करेगा?',
  'link.faq.a4': 'हां, जब तक वीडियो सार्वजनिक और सुलभ रहता है, टाइमस्टैम्प लिंक काम करता रहेगा। यदि वीडियो हटा दिया जाता है या निजी बना दिया जाता है, तो लिंक काम नहीं करेगा।',

  'link.faq.q5': 'क्या मैं लिंक में अंतिम समय जोड़ सकता हूं?',
  'link.faq.a5': 'हां, आप &end= पैरामीटर जोड़ सकते हैं: ?t=90&end=180 1:30 से 3:00 तक चलेगा',

  'link.faq.q6': 'मुझे किस प्रारूप का उपयोग करना चाहिए - ?t= या #t=?',
  'link.faq.a6': '?t= (क्वेरी पैरामीटर) प्रारूप का उपयोग करें। यह आधुनिक मानक है और सभी प्लेटफार्मों में अधिक विश्वसनीय रूप से काम करता है। #t= प्रारूप पुराना है और कम संगत है।',

  // Related Tools
  'link.relatedTools': 'संबंधित YouTube टूल',
  'link.needChapters': 'वीडियो अध्याय बनाने की आवश्यकता है?',
  'link.needChaptersDesc': 'वीडियो विवरण और टिप्पणियों के लिए अध्याय टाइमस्टैम्प बनाने के लिए हमारे YouTube टाइमस्टैम्प जनरेटर का उपयोग करें।',
  'link.checkGenerator': 'YouTube टाइमस्टैम्प जनरेटर देखें',

  'link.needUnixTime': 'Unix टाइमस्टैम्प के साथ काम कर रहे हैं?',
  'link.needUnixTimeDesc': 'हमारे टाइमस्टैम्प कनवर्टर के साथ Unix टाइमस्टैम्प को पठनीय तारीखों में कन्वर्ट करें।',

  // How to Use
  'link.howToUse': 'YouTube टाइमस्टैम्प लिंक कैसे बनाएं',
  'link.step1': 'YouTube वीडियो URL कॉपी करें',
  'link.step1Desc': 'ब्राउज़र एड्रेस बार या शेयर बटन से URL प्राप्त करें',

  'link.step2': 'शुरू होने का समय दर्ज करें',
  'link.step2Desc': 'समय पिकर का उपयोग करें या सीधे सेकंड दर्ज करें',

  'link.step3': 'अपना पसंदीदा लिंक प्रारूप कॉपी करें',
  'link.step3Desc': 'संक्षिप्त लिंक, पूर्ण लिंक या एम्बेड कोड के बीच चुनें',

  'link.step4': 'कहीं भी साझा करें!',
  'link.step4Desc': 'सोशल मीडिया, ईमेल, फ़ोरम और मैसेजिंग ऐप्स पर काम करता है',

  // Additional Tips
  'link.tips': 'प्रो टिप्स',
  'link.tip1': '💡 सोशल मीडिया के लिए संक्षिप्त लिंक (youtu.be) का उपयोग करें - वे साफ हैं और कम जगह लेते हैं',
  'link.tip2': '💡 त्वरित साझाकरण के लिए YouTube वीडियो पर राइट-क्लिक करें और "वर्तमान समय पर वीडियो URL कॉपी करें" चुनें',
  'link.tip3': '💡 टाइमस्टैम्प प्लेलिस्ट के साथ भी काम करते हैं: बस प्लेलिस्ट URL में &t=90 जोड़ें',
  'link.tip4': '💡 आप अन्य पैरामीटर के साथ भी जोड़ सकते हैं जैसे प्लेलिस्ट के लिए &list= या &autoplay=1',
};